function open_popup_moneyback() {
  const slider = document.querySelector('#moneyBackGuaranteeSlider');
  if (slider) {
    slider.classList.add('open');
    setTimeout(() => {
      document.body.classList.add('overflow-hidden');
    }, 200);
  }
}

function closeMoneyBackGuaranteeDrawer() {
  const slider = document.querySelector('#moneyBackGuaranteeSlider');
  if (slider) {
    slider.classList.remove('open');
    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
    }, 200);
  }
}
document.addEventListener('click', (event) => {
  if (!event.target.closest('.moneyBackGuaranteeSlider_white') && !event.target.closest('.money_back_button')) {
    closeMoneyBackGuaranteeDrawer();
  }
});